import { coinDecimal } from "./const";
import DefaultProfileImage from "@/assets/images/icons/account_circle_gray-200.svg";

export const getCssVariableValue = (variableName) => {
  const rootStyles = window.getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue(variableName);
};

/**
 *
 * USDT 소수점 한자리까지 표시, 나머지는 버림
 * XRP 정수로 표시, 나머지는 버림
 * ETH 소수점 세자리까지 표시, 나머지는 버림
 * BTC 소수점 네 자리까지 표시, 나머지는 버림
 */

export const getDecimalUnitCount = (coinKey) => {
  if (!coinKey) return 0;
  const key = isNaN(coinKey) ? coinKey.toUpperCase() : Number(coinKey);
  const coin = coinDecimal.find(
    (ob) => ob.key === key || ob.value.toUpperCase() === key
  );
  return coin ? coin.decimal : 0;
};

export const getCoinName = (coinKey) => {
  if (!coinKey) return;
  const coin = coinDecimal.find((ob) => ob.key == Number(coinKey));
  return coin.value;
};

/**
 * @param {Number} number -29.356633
 * @param {Number} digit  2
 * @returns 29.35
 */

export const cuttingDecimal = (number, digit = 2) => {
  if (Number.isInteger(number)) return number;
  const factor = Math.pow(10, digit);
  const truncated = Math.trunc(number * factor) / factor;
  return truncated;
};

export const arrayToFillString = (value) => {
  const result = [];
  for (const [no, count] of Object.entries(value)) {
    const array = Array(count).fill(no);
    result.push(...array);
  }
  return result.join(",");
};

// 정수 + 금액 (,)
export const getNumberByNaN = (value) =>
  isNaN(value) ? 0 : parseInt(value).toLocaleString();

// 소수점 한 자리 + 금액 (,)
export const toLocalNum = (value, digit = 1) => {
  return isNaN(value)
    ? 0
    : Number(value).toLocaleString(undefined, {
        minimumFractionDigits: digit,
        maximumFractionDigits: digit,
      });
};

/**
 * @param value
 * Number value to be dollar format with comma
 * @returns {`$${string}`}
 */
export const dollarFormat = (value) => {
  const result = Number(value || 0)
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

  return `$${result}`;
};

export const dollarFormatWithFixed = (value) => {
  const fixedValue = Number(value).toFixed(getDecimalUnitCount(104));
  const result = Number(fixedValue || 0)
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

  return `$${result}`;
};

// $ 정수
export const dollarIntFormat = (value) => {
  return `$${getNumberByNaN(value)}`;
};

/**
 * @param value
 * Number value with comma
 * @returns {string}
 */
export const addComma = (value) => {
  return Number(value || 0)
    .toString()
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
};

export const getProfileImg = (value) => {
  return value || DefaultProfileImage;
};

// 날짜 변환 함수
export const formatTimestamp = (timestamp) => {
  const time = timestamp * 1000;
  const toDate = new Date(time);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hour12: false,
    minute: "2-digit",
    timeZone: "Asia/Seoul",
  };
  const timestampToString = toDate.toLocaleString("ko-KR", options);

  return timestampToString;
};

export const formatTimestampWithHyphen = (timestamp) => {
  const time = timestamp * 1000;
  const toDate = new Date(time);

  const year = toDate.getFullYear();
  const month = String(toDate.getMonth() + 1).padStart(2, "0"); // getMonth()는 0부터 시작하므로 1을 더합니다.
  const day = String(toDate.getDate()).padStart(2, "0");
  const hour = String(toDate.getHours()).padStart(2, "0");
  const minute = String(toDate.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hour}:${minute}`;
};
